import { SlidersHorizontal, Sparkles } from 'lucide-react-native';
import { memo } from 'react';
import { BiButton } from '../components/ui/BiButton';

/** The card page's header actions: ask the AI, and on a phone 配置. */
export const CardDetailActions = memo(
  ({
    compact,
    showChat,
    onChat,
    onConfigure,
  }: {
    compact: boolean;
    /** False while the chat already sits beside the page. */
    showChat: boolean;
    onChat: () => void;
    /** Given where the configuration opens as a sheet. */
    onConfigure: (() => void) | null;
  }) => (
    <>
      {showChat ? (
        <BiButton
          icon={Sparkles}
          title={compact ? undefined : '问 AI'}
          accessibilityLabel="问 AI"
          onPress={onChat}
        />
      ) : null}
      {onConfigure ? (
        <BiButton
          icon={SlidersHorizontal}
          title="配置"
          accessibilityLabel="配置"
          tone="primary"
          onPress={onConfigure}
        />
      ) : null}
    </>
  ),
);
